import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Redirect to ICF page by icdId

// Event handler when user clicks one of the FAQ item
export const expandFAQContent = (articleId, icfId) => ({ type: types.EXPAND_FAQ_CONTENT, payload: { articleId, icfId } });

export const icfClicked = (icfId) => ({
  type: types.ICF_SELECTED,
  payload: icfId,
});

export const guideClicked = (guide) => ({
  type: types.GUIDE_CLICKED,
  payload: guide,
});

const updateVisitedICFAccessList = (payload) => ({ type: types.UPDATE_VISITED_ACCESS_LIST, payload });

const requestSetICFAccessedArticle = () => ({ type: types.REQUEST_SET_ICF_ACCESSED_ARTICLE });

const receivedSetICFAccessedArticle = (payload) => ({ type: types.RECEIVED_SET_ICF_ACCESSED_ARTICLE, payload });

const receviedSetICFAccessedArticleError = () => ({ type: types.RECEIVED_SET_ICF_ACCESSED_ARTICLE_ERROR });

export const setICFAccessArticle = (icfId, faqId) => (dispatch) => {
  dispatch(requestSetICFAccessedArticle());
  return axios.get(`/smarthelp/set-icf-visit?icfId=${icfId}&faqId=${faqId}`)
    .then((response) => {
      dispatch(receivedSetICFAccessedArticle(response.data));
    })
    .catch(() => {
      dispatch(receviedSetICFAccessedArticleError());
    });
};

const requestGetICFAccessedArticle = () => ({ type: types.REQUEST_GET_ICF_ACCESSED_ARTICLE });

const receviedGetICFAccessedArticleError = () => ({ type: types.RECEIVED_GET_ICF_ACCESSED_ARTICLE_ERROR });

export const getICFAccessdArticle = () => (dispatch) => {
  dispatch(requestGetICFAccessedArticle());
  return axios.get('/smarthelp/get-icf-visit')
    .then((response) => {
      dispatch(updateVisitedICFAccessList(response.data && response.data.icfAccessedList));
    })
    .catch(() => {
      dispatch(receviedGetICFAccessedArticleError());
    });
};
